






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import makeSelectOptions from "@common/util/makeSelectOptions";
import trackingNumberScanItemStatuses from "@/constants/trackingNumberScanItemStatuses";

export default Vue.extend({
  data() {
    return {
      self: this,
      tableOptions: null,
      userManager,
    };
  },
  methods: {
    makeTableOptions(country) {
      return {
        attrs: {
          "item-key": "_id",
          "sort-by": "time",
          "sort-desc": true,
        },
        content: {
          name: "Import - Return Scan History",
          urlEnabled: true,
          search: {},
          displayFields: {
            time: {
              text: "Return time",
              sortableable: true,
              options: {
                filter: "dateTime",
              },
            },
            warehouse: {
              text: "Warehouse",
              sortable: true,
              options: {
                subProp: "order.warehouse.name",
              },
            },
            market: {
              text: "Market",
              sortable: true,
              options: {
                subProp: "market.name",
              },
            },
            shippingCompany: {
              text: "Shipping company",
              options: {
                subProp: "shippingCompany.name",
              },
            },
            transportTrackingNumber: {
              text: "Tracking number",
            },
            orderId: {
              text: "Order ID",
              options: {
                subProp: "order.orderId",
              },
            },
            productItemSkus: {
              text: "SKU",
              sortable: true,
              options: {
                labels(_, item) {
                  return item.productItems.map((productItem) => productItem.product.sku);
                },
                labelsSeparatedByNewLine: true,
              },
            },
            productItemCounts: {
              text: "Count",
              options: {
                labels(_, item) {
                  return item.productItems.map((productItem) => productItem.count);
                },
                labelsSeparatedByNewLine: true,
              },
            },
            productItemRealCounts: {
              text: "Actual count",
              options: {
                labels(_, item) {
                  return item.productItems.map((productItem) => productItem.realCount);
                },
                labelsSeparatedByNewLine: true,
              },
            },
            productItemFailedCounts: {
              text: "Damaged count",
              options: {
                labels(_, item) {
                  return item.productItems.map((productItem) => productItem.failedCount);
                },
                labelsSeparatedByNewLine: true,
              },
            },
            productItemSwitchedCounts: {
              text: "Switched count",
              options: {
                labels(_, item) {
                  return item.productItems.map((productItem) => productItem.switchedCount);
                },
                labelsSeparatedByNewLine: true,
              },
            },
            productItemLostCounts: {
              text: "Not received",
              options: {
                labels(_, item) {
                  return item.productItems.map((productItem) => productItem.count - productItem.realCount - (productItem.failedCount || 0) - (productItem.switchedCount || 0));
                },
                labelsSeparatedByNewLine: true,
              },
            },
            user: {
              text: "User account",
              options: {
                subProp: "user.name",
              },
            },
            action: {},
          },
          filters: {
            filters: {
              time: {
                type: "XDateTimePicker",
                rules: {
                  greater_than_or_equal_to: {
                    attrs: {
                      label: "Ngày kiểm kê (bắt đầu)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.startOf("day"),
                        },
                      },
                    },
                  },
                  less_than_or_equal_to: {
                    attrs: {
                      label: "Ngày kiểm kê (kết thúc)",
                      xOptions: {
                        content: {
                          resultFilter: (m) => m.endOf("day"),
                        },
                      },
                    },
                  },
                },
              },
              warehouseId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Warehouse",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsLoader() {
                        const { items } = await coreApiClient.call("warehouses", "findAll", {
                          payload: JSON.stringify({
                            limit: -1,
                            filters: [
                              {
                                key: "countryId",
                                operator: "equal_to",
                                value: country._id,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              marketId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Market",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsLoader() {
                        const { items } = await coreApiClient.call("markets", "findAll", {
                          payload: JSON.stringify({
                            limit: -1,
                            filters: [
                              {
                                key: "countryId",
                                operator: "equal_to",
                                value: country._id,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              createdByUserId: {
                type: "XAutocomplete",
                attrs: {
                  label: "User account",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("users", "findAll", {
                          payload: JSON.stringify({
                            search,
                            limit,
                            filters: [
                              {
                                key: "_id",
                                operator: "in",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              transportTrackingNumber: {
                attrs: {
                  label: "Tracking number",
                },
                rules: {
                  equal_to: {},
                },
              },
              shippingCompanyId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Shipping Company",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsLoader() {
                        const { items } = await coreApiClient.call("shippingCompanies", "findAll", {
                          payload: JSON.stringify({
                            limit: -1,
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              "productItems.productId": {
                type: "XAutocomplete",
                attrs: {
                  label: "SKU",
                  "item-value": "_id",
                  "item-text": "sku",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("products", "findAll", {
                          payload: JSON.stringify({
                            search,
                            limit,
                            filters: [
                              {
                                key: "countryId",
                                operator: "equal_to",
                                value: country._id,
                              },
                              {
                                key: "_id",
                                operator: "in",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              orderId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Order ID",
                  "item-value": "_id",
                  "item-text": "orderId",
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("orders", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            filters: [
                              {
                                key: "_id",
                                operator: "in",
                                value,
                              },
                              {
                                key: "orderId",
                                operator: "equal_to",
                                value: search,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  in: {},
                },
              },
              statuses: {
                type: "selectMultiple",
                attrs: {
                  label: "Status",
                  items: makeSelectOptions(trackingNumberScanItemStatuses),
                },
                rules: {
                  in: {},
                },
              },
            },
          },
          topActionButtons: {
            export: {
              attrs: {
                color: "default",
                dark: false,
              },
              content: {
                text: "Export Excel",
                icon: "mdi-microsoft-excel",
              },
              on: {
                xClick({ self }) {
                  const dataTable = self.context();
                  let findAllOptions = dataTable.getFindAllOptions();
                  if (dataTable.model.value.length) {
                    findAllOptions = {
                      payload: JSON.stringify({
                        filters: [
                          {
                            key: "_id",
                            operator: "in",
                            value: dataTable.model.value.map((item) => item._id),
                          },
                        ],
                        limit: -1,
                      }),
                    };
                  }
                  coreApiClient.download("trackingNumberScanItems", `@/export`, findAllOptions);
                },
              },
            },
          },
          template: {
            itemActionButtons: {
              delete: userManager.checkRole(["admin"]) && {},
            },
          },
          findAllOptionsFilter(options) {
            options.filters.push({
              key: "countryId",
              operator: "equal_to",
              value: country._id,
            });
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("trackingNumberScanItems", "findAll", options);
              return [items, count];
            },
            async delete(item) {
              return await coreApiClient.call("trackingNumberScanItems", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            delete: userManager.checkRole(["admin"]) && {
              confirmDisplayField: "_id",
            },
          },
        },
      };
    },
  },
  async created() {
    const country = await coreApiClient.call("countries", "findById", {
      id: this.$route.params.countryId,
    });
    this.tableOptions = this.makeTableOptions(country);
  },
});
